import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { WorkstationLine } from 'src/app/models/workstationline';
import { WorkstationService } from 'src/app/services/workstation.service';
import { LayoutService } from '../../../../../services/layout.service';

@Component({
  selector: 'app-workstation-list',
  templateUrl: './workstation-list.component.html',
  styleUrls: ['./workstation-list.component.css'],
})
export class WorkstationListComponent implements OnInit {
  @Input() ITEM: any;
  @Input() ITEMID: any;
  @Input() disabled: boolean = false;
  @Input() allAttr: any;

  @ViewChild(MatTable) table: MatTable<any>;
  selectedColumns: string[] = ['workstation_name', 'minutes', 'del'];
  isHandset = this.layoutService.isHandset;

  constructor(
    private readonly workstationService: WorkstationService,
    private readonly layoutService: LayoutService
  ) {}

  ngOnInit(): void {
    this.workstationService.initializeLines(this.ITEM, this.ITEMID);
    console.log(this.ITEM);
    if (this.ITEM?.fld_code_ent === 'productionorder_workstation_list') {
      this.selectedColumns = [
        'workstation_name',
        'minutes',
        'working',
        'ended_at',
        'del',
      ];
    }
  }

  ngAfterViewInit(): void {
    this.workstationService.loadInitialLines(this.ITEMID);
  }

  removeItemLine(index: number): void {
    this.workstationService.removeLine(index);
    this.table.renderRows();
  }

  fillWorkstationlineItem(item: any, line: WorkstationLine): void {
    this.workstationService.fillWorkstationLine(item, line);
    this.table.renderRows();
  }

  addItemLine(item: any): void {
    this.workstationService.addLine(item);
    this.table.renderRows();
  }

  onWorkingChange(line: WorkstationLine): void {
    this.workstationService.updateWorkingStatus(line);
  }

  get lines(): WorkstationLine[] {
    return this.workstationService.getLines();
  }
}
